import { APICall, GetRequest } from "../service"

const ControllerName = "Country"

export const GetCountryLookup = () =>
    GetRequest(`${ControllerName}/lookup`)
